/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Company200,
  GetApiV1Company400,
  GetApiV1Company401,
  GetApiV1Company500,
  GetApiV1CompanyQueryParams,
  GetApiV1CompanyQueryResponse,
} from "../../types/companyListingController/GetApiV1Company.ts";
import { companyGridItemViewModelPaginatedResponseSchema } from "../companyGridItemViewModelPaginatedResponseSchema.ts";

export const getApiV1CompanyQueryParamsSchema = z.object({
  Search: z.optional(z.string()),
  CompanyId: z.optional(z.coerce.number().int()),
  PageNumber: z.coerce.number().int().default(1),
  PageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1CompanyQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Company200Schema = z.lazy(
  () => companyGridItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Company200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1Company400Schema =
  z.any() as unknown as ToZod<GetApiV1Company400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Company401Schema =
  z.any() as unknown as ToZod<GetApiV1Company401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Company500Schema =
  z.any() as unknown as ToZod<GetApiV1Company500>;

export const getApiV1CompanyQueryResponseSchema = z.lazy(
  () => getApiV1Company200Schema,
) as unknown as ToZod<GetApiV1CompanyQueryResponse>;
